import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL;

// 1. Define the initial state as a constant so it can be reused for resetting.
const initialFormState = {
    prodname: "",
    hsncode: "",
    uom: "",
    taxpercent: 0,
    cost_price: "",
};

const AddProductModal = ({ isOpen, onClose, onSuccess }) => {
    const [form, setForm] = useState(initialFormState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const token = localStorage.getItem("token");
    const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

    // 2. Add a useEffect hook to reset the form whenever the modal opens.
    useEffect(() => {
        if (isOpen) {
            setForm(initialFormState);
        }
    }, [isOpen]); // This effect runs every time the 'isOpen' prop changes.

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.prodname || !form.uom || !form.cost_price) {
            toast.error("Product Name, UOM, and Initial Cost Price are required.");
            return;
        }
        setIsSubmitting(true);
        try {
            const payload = {
                ...form,
                taxpercent: parseFloat(form.taxpercent) || 0,
                cost_price: parseFloat(form.cost_price) || 0,
            };
            await axios.post(`${API_URL}/products`, payload, { headers });
            toast.success("Product added successfully!");
            onSuccess(); // Trigger parent to close modal and refresh
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed to add product");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Add New Product</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="prodname">Product Name</label>
                            <input id="prodname" name="prodname" value={form.prodname} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="hsncode">HSN Code</label>
                            <input id="hsncode" name="hsncode" value={form.hsncode} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="uom">Unit of Measurement (UOM)</label>
                            <input id="uom" name="uom" value={form.uom} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="taxpercent">Tax %</label>
                            <input id="taxpercent" name="taxpercent" type="text" inputMode="decimal" placeholder="0.00" value={form.taxpercent} onChange={handleChange} />
                        </div>
                        
                        <div className="form-group">
                            <label htmlFor="cost_price">Initial Cost Price</label>
                            <input 
                                id="cost_price" 
                                name="cost_price" 
                                type="text" 
                                inputMode="decimal" 
                                placeholder="0.00"
                                value={form.cost_price} 
                                onChange={handleChange} 
                                required 
                            />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                {isSubmitting ? "Saving..." : "Save Product"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddProductModal;
